module.exports = __webpack_public_path__ + "static/media/c1-bg.a8c0b527.jpg";